import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import ModalLoader from 'components/modals/ModalLoader';

export default class CollapsibleModalContainer extends Component {
    static propTypes = {
        children: PropTypes.node,
        title: PropTypes.node,
        footer: PropTypes.node,
        className: PropTypes.string,
        refresh: PropTypes.func,
        meta: PropTypes.object
    };

    static defaultProps = {
        meta: {}
    };

    render() {
        const { refresh, meta, children, footer = null, title, className } = this.props;

        return (
            <Fragment>
                { title &&
                    <div className='ant-modal-header'>
                        <div className='ant-modal-title'>
                            { title }
                        </div>
                    </div>
                }
                <ModalLoader refresh={refresh} meta={meta} className={`collapsible-modal-body ${className || ''}`}>
                    { children }
                </ModalLoader>
                { footer &&
                    <div className='ant-modal-footer'>
                        { footer }
                    </div>
                }
            </Fragment>
        );
    }
}
